const NullRenderer = function () {};

NullRenderer.prototype.init = function () {};

NullRenderer.prototype.render = function () {};

NullRenderer.prototype.resize = function () {};

NullRenderer.prototype.destroy = function () {};

export {
    NullRenderer,
};
